import axios from "axios";
import qs from "qs";

export const getRates = async (params: any): Promise<{
    list: {
        code: string,
        label: string
    }[]
}> => {
    console.log({ params })
    const response = await axios.get('/booking/rule/rates', {
        params: { ...params, tenants: params.tenants?.join(',') || "", dealers: params.dealers?.join(',') || "drivalia" },
        paramsSerializer: (params) => qs.stringify(params, { arrayFormat: 'repeat', skipNulls: true })
    })
    return response.data;
};